<script setup>
import { ref, watchEffect } from 'vue'
import Select2 from 'vue3-select2-component'

const props = defineProps({
  allowClear: {
    type: Boolean,
    default: true,
  },
  modelValue: {
    type: [Number, String],
    default: '',
  },
  options: Array,
})

const localValue = ref(props.modelValue)
const emit = defineEmits(['update:modelValue'])

const settings = {
  allowClear: props.allowClear,
  language: 'es',
  placeholder: 'Seleccionar',
}

const handleEvent = ({ id, text }) => {
  parseInt(props.modelValue) === parseInt(id)
    ? emit('update:modelValue', null)
    : emit('update:modelValue', parseInt(id))
}

watchEffect(() => {
  localValue.value = props.modelValue || ''
})
</script>

<template>
  <Select2
    v-model="localValue"
    :options="options"
    :placeholder="'Seleccionar'"
    :settings="settings"
    @change="handleEvent($event)"
    @select="handleEvent($event)"
  ></Select2>
</template>

<style lang="scss">
.select2-container--default {
  .select2-selection--single {
    border-color: #d3d3d3;
    border-radius: 1.5rem;
    display: grid;
    grid-template-columns: auto 2rem;
    height: auto;

    .select2-selection__rendered {
      align-items: center;
      color: #4b4b4b;
      font-size: 1rem;
      height: 2.5rem;
      line-height: 40px;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
      padding-left: 1rem;
      padding-right: 0;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .select2-selection__arrow {
      bottom: auto;
      height: 100%;
      position: relative;
      width: 2rem;
    }
  }

  &.select2-container--open {
    &.select2-container--above,
    &.select2-container--below {
      .select2-selection--single,
      .select2-selection--multiple {
        border-radius: 1.5rem;
      }
    }
  }

  .select2-search--dropdown {
    .select2-search__field {
      border-color: #d3d3d3;
    }
  }

  .select2-results__option--highlighted[aria-selected] {
    background-color: #f5f5f5;
    color: #000;
  }
}

.select2-dropdown {
  border: 1px solid #d3d3d3;
  border-radius: 1.5rem;
}

.select2-search--dropdown {
  padding: 0.5rem;

  .select2-search__field {
    border-color: #d3d3d3;
    border-radius: 1.5rem;
    font-size: 1rem;
    height: 2.5rem;
    padding: 0 1rem;
  }
}

.select2-container--open {
  .select2-dropdown--above,
  .select2-dropdown--below {
    border: 1px solid #d3d3d3;
    border-radius: 1.5rem;
  }
}

.select2-results {
  padding: 0 0.5rem 1rem;
}

.select2-results__options {
  padding-right: 0.5rem;
}

.select2-results__option {
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.select2-container {
  display: block;
  width: 100% !important;

  .select2-selection--single {
    .select2-selection__clear {
      flex: 0 0 auto;
      text-align: center;
      width: 20px;
    }
  }
}
</style>
